import React from "react";
import { checkAuth } from "../actions";
import { connect } from "react-redux";
import { AnimatedLogo } from "./AnimatedLogo";

class Auth extends React.Component {
  componentDidMount() {
    this.props.checkAuth(this.props.location.pathname);
  }
  render() {
    const { loaderWrapper } = styles;
    return (
      <div style={loaderWrapper}>
        <AnimatedLogo />
      </div>
    );
  }
}

const styles = {
  loaderWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#fafafa",
    flexDirection: "column"
  },
  title: {
    margin: "5px",
    fontSize: "12px",
    letterSpacing: "1px",
    fontWeight: "100",
    color: "#bbb"
  }
};

const AU = connect(null, { checkAuth })(Auth);

export { AU as Auth };
